"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _rendererCore = require("@quillforms/renderer-core");
var _tinycolor = _interopRequireDefault(require("tinycolor2"));
var _reactAutosizeTextarea = _interopRequireDefault(require("react-autosize-textarea"));
var _emotion = require("emotion");
var _classnames = _interopRequireDefault(require("classnames"));
/**
 * QuillForms Depndencies
 */

/**
 * WordPress Dependencies
 */

/**
 * External Dependencies
 */

const LongTextOutput = props => {
  const {
    id,
    attributes,
    setIsValid,
    setIsAnswered,
    setValidationErr,
    showNextBtn,
    blockWithError,
    val,
    setVal,
    showErrMsg,
    next,
    inputRef,
    isTouchScreen,
    setFooterDisplay,
    isReviewing,
    isPreview
  } = props;
  const {
    minCharacters,
    setMaxCharacters,
    maxCharacters,
    required,
    placeholder
  } = attributes;
  const theme = (0, _rendererCore.useBlockTheme)(attributes.themeId);
  const messages = (0, _rendererCore.useMessages)();
  const answersColor = (0, _tinycolor.default)(theme.answersColor);
  const checkfieldValidation = value => {
    if (required === true && (!value || value === '')) {
      setIsValid(false);
      setValidationErr(messages['label.errorAlert.required']);
    } else if (setMaxCharacters && maxCharacters > 0 && value?.length > maxCharacters) {
      setIsValid(false);
      setValidationErr(messages['label.errorAlert.maxCharacters']);
    } else if (minCharacters !== false && minCharacters > 0 && value?.length < minCharacters) {
      setIsValid(false);
      setValidationErr(messages['label.errorAlert.minCharacters']);
    } else {
      setIsValid(true);
      setValidationErr(null);
    }
  };
  (0, _react.useEffect)(() => {
    if (isPreview || !isReviewing) checkfieldValidation(val);
  }, [attributes]);
  const keyDownHandler = e => {
    // Enter was pressed with shift key or not
    if (e.keyCode === 13) {
      if (e.shiftKey) {
        // prevent default behavior
        e.stopPropagation();
      } else {
        e.preventDefault();
      }
    }
  };
  const changeHandler = e => {
    const value = e.target.value;
    if (setMaxCharacters && maxCharacters > 0 && value.length > maxCharacters) {
      blockWithError(messages['label.errorAlert.maxCharacters']);
    } else {
      setVal(value);
      showErrMsg(false);
      checkfieldValidation(value);
    }
    if (value !== '') {
      setIsAnswered(true);
      showNextBtn(true);
    } else {
      setIsAnswered(false);
    }
  };
  return (0, _react.createElement)(_react.Fragment, null, (0, _react.createElement)(_reactAutosizeTextarea.default, {
    ref: inputRef,
    onKeyDown: keyDownHandler,
    className: (0, _classnames.default)((0, _emotion.css)`
						& {
							width: 100%;
							height: 120px;
							padding: 10px;
							border: none !important;
							outline: none;
							border-radius: 0 !important;
							padding-bottom: 8px;
							background: ${(0, _tinycolor.default)(answersColor).setAlpha(0.1).toString()} !important;
							transition: box-shadow 0.1s ease-out 0s;
							resize: none;
							box-shadow: ${answersColor.setAlpha(0.3).toString()}
								0px 3px !important;
						}

						&::placeholder {
							opacity: 0.3;
							/* Chrome, Firefox, Opera, Safari 10.1+ */
							color: ${theme.answersColor};
						}

						&:-ms-input-placeholder {
							opacity: 0.3;
							/* Internet Explorer 10-11 */
							color: ${theme.answersColor};
						}

						&::-ms-input-placeholder {
							opacity: 0.3;
							/* Microsoft Edge */
							color: ${theme.answersColor};
						}

						&:focus {
							box-shadow: ${answersColor.setAlpha(1).toString()}
								0px 4px !important;
						}

						color: ${theme.answersColor} !important;
						-webkit-appearance: none;
					`),
    id: 'longText-' + id,
    placeholder: placeholder === false ? messages['block.longText.placeholder'] : placeholder,
    onChange: changeHandler,
    value: val && val.length > 0 ? val : '',
    onFocus: () => {
      if (isTouchScreen) {
        setFooterDisplay(false);
      }
    },
    onBlur: () => {
      if (isTouchScreen) {
        setFooterDisplay(true);
      }
    },
    autoComplete: "off"
  }), (0, _react.createElement)("div", {
    className: (0, _classnames.default)('qf-blocklib-long-text-block-renderer__hint-text', (0, _emotion.css)`
						margin-top: 12px;
						color: ${theme.questionsColor};
						font-size: 14px;
					`)
  }, (0, _react.createElement)(_rendererCore.HTMLParser, {
    value: isTouchScreen ? messages['block.longText.touchHint'] : messages['block.longText.hint']
  })));
};
var _default = exports.default = LongTextOutput;
//# sourceMappingURL=display.js.map